<template>
    <section>
        Hero
    </section>
</template>
